<template>
  <tsoft-wrapper class="ticket-form">
    <b-form-group label="Тема обращения">
      <b-form-input v-model="formData.title"></b-form-input>
    </b-form-group>

    <label>Описание</label>
    <div>
      <VueEditor v-model="formData.comment" :editorToolbar="customToolbar" />
    </div>

    <tsoft-upload-file :value="formData.file" @file="getFile" />

    <b-overlay
      :show="loading.ticket"
      rounded
      opacity="0.6"
      spinner-small
      spinner-variant="primary"
      class="d-inline-block mt-4"
    >
      <b-button :disabled="!validate || loading.ticket" @click="submit"
        >Отправить
      </b-button>
    </b-overlay>
  </tsoft-wrapper>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { VueEditor } from "vue2-editor";

import tsoftUploadFile from "@components/uploadFile/UploadFile.vue";

export default {
  name: "TicketForm",
  components: {
    VueEditor,
    tsoftUploadFile,
  },

  data() {
    return {
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ color: [] }, { background: [] }],
      ],
      formData: {
        comment: "",
        title: "",
        file: null,
      },
    };
  },

  computed: {
    ...mapGetters("tickets", ["loading"]),
    ...mapGetters("auth", ["currentUser"]),

    createFormData() {
      return {
        ...this.formData,
        userName: this.currentUser.name,
        userId: this.currentUser.id,
        priorityId: 1,
      };
    },

    validate() {
      return this.formData.comment.length > 0 && this.formData.title.length > 0;
    },
  },

  methods: {
    ...mapActions("tickets", ["fetchTickets", "postTicket"]),

    resetFormData() {
      this.formData = {
        comment: "",
        title: "",
        file: null,
      };
    },

    submit() {
      this.postTicket(this.createFormData).then(() => {
        this.resetFormData();
      });
    },

    getFile(file) {
      this.formData.file = file;
    },
  },
};
</script>
